// extracted by mini-css-extract-plugin
module.exports = {"container":"NotYetWrittenBanner_container__QjCa0","noContent":"NotYetWrittenBanner_noContent__cMnHy","aside":"NotYetWrittenBanner_aside__vBgZ9"};